import { AlertTriangle, Zap, Flame, DollarSign, ShieldAlert, FileWarning } from "lucide-react";
import { AnimatedSection } from "@/components/AnimatedSection";

const PainPoints = () => {
  const problems = [
    {
      icon: Zap,
      text: "Cortes de luz constantes en tu local",
      color: "text-yellow-400"
    },
    {
      icon: Flame,
      text: "Equipos que se queman sin razón aparente",
      color: "text-orange-400"
    },
    {
      icon: ShieldAlert,
      text: "Tablero eléctrico antiguo o sin mantención",
      color: "text-red-400"
    },
    {
      icon: DollarSign,
      text: "Consumo eléctrico muy alto",
      color: "text-green-400"
    },
    {
      icon: AlertTriangle,
      text: "Miedo a un incendio eléctrico",
      color: "text-red-500"
    },
    {
      icon: FileWarning,
      text: "No tienes certificación SEC actualizada",
      color: "text-amber-400"
    }
  ];

  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-industrial-gray via-dark-section/90 to-dark-section">
        <div className="absolute top-20 right-10 w-96 h-96 bg-red-500/20 rounded-full blur-3xl animate-pulse opacity-20" />
      </div>

      <div className="relative z-10 container mx-auto px-4">
        <AnimatedSection animation="fade-in">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-montserrat font-bold text-white text-center mb-4">
            ¿Te ha pasado esto?
          </h2>
          <p className="text-lg text-white/70 text-center mb-12 max-w-2xl mx-auto">
            Un problema eléctrico puede cerrar tu negocio por días o semanas. No arriesgues tus ingresos.
          </p>
        </AnimatedSection>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto">
          {problems.map((problem, index) => (
            <AnimatedSection
              key={index}
              animation="slide-up"
              delay={index * 50}
            >
              <div className="backdrop-blur-xl bg-white/5 border-2 border-red-500/30 rounded-2xl p-6 hover:bg-white/10 hover:border-red-500/50 transition-all duration-300 hover:scale-105 group">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <problem.icon className={`w-8 h-8 ${problem.color} group-hover:scale-110 transition-transform`} />
                  </div>
                  <p className="text-white/90 font-medium leading-relaxed">{problem.text}</p>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>

        <AnimatedSection animation="scale-in" delay={300}>
          <div className="backdrop-blur-2xl bg-red-500/10 border-2 border-red-500/30 rounded-3xl p-8 mt-12 max-w-3xl mx-auto text-center">
            <AlertTriangle className="w-16 h-16 text-red-400 mx-auto mb-4" />
            <p className="text-xl md:text-2xl font-montserrat font-bold text-white mb-2">
              ¡No esperes a que sea tarde!
            </p>
            <p className="text-white/80">
              El 40% de los incendios en locales comerciales son causados por fallas eléctricas.
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default PainPoints;
